<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="search(1)"> 查询 </el-button>
      <el-button v-if="ERP.isPermission(4004002001)" @click="modals">
        添加税盘
      </el-button>
    </div>
    <el-descriptions
      style="margin-top: 8px; margin-left: 8px"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="公司名称/纳税人识别号">
        <el-input
          size="mini"
          v-model="searchForm.keyword"
          placeholder="输入公司名称/纳税人识别号搜索"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item label=""> </el-descriptions-item>
    </el-descriptions>
    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border
    >
      <el-table-column label="公司名称" prop="name" />
      <el-table-column label="纳税人识别号" prop="tax_number" />
      <el-table-column label="地址/电话" prop="address" />
      <el-table-column label="开户行及账号" prop="bank" />
      <el-table-column label="电话/邮箱" prop="tel" />
      <el-table-column label="开票人" prop="drawer" />
      <el-table-column label="收款人" prop="payee" />
      <el-table-column label="复核人" prop="inspector" />
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="备注" prop="remark" />
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-link
            v-if="ERP.isPermission(4004002002)"
            type="primary"
            :underline="false"
            @click="edit(data.row.id)"
          >
            修改
          </el-link>
          <el-link
            v-if="ERP.isPermission(4004002003)"
            type="primary"
            :underline="false"
            @click="del(data.row.id)"
          >
            删除
          </el-link>
          <el-link
            v-if="ERP.isPermission(4004002004)"
            type="primary"
            :underline="false"
            @click="project(data.row)"
          >
            管理项目
          </el-link>
          <el-link
            v-if="
              data.row.is_digitization == true && ERP.isPermission(4004002005)
            "
            type="primary"
            :underline="false"
            @click="digitization(data.row)"
          >
            全电票验证
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="listData">
      <Page
        :total="searchForm.totalCount"
        :page-size="searchForm.pageSize"
        @on-change="search"
        show-total
      />
    </div>
    <el-dialog
      title="税盘管理"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="开通全电票" prop="is_digitization">
          <el-switch
            style="display: block"
            v-model="form.is_digitization"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开通"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="tax_number">
          <el-input v-model="form.tax_number" />
        </el-form-item>
        <el-form-item label="地址/电话" prop="address">
          <el-input v-model="form.address" />
        </el-form-item>
        <template v-if="!form.is_digitization">
          <el-form-item label="开户行及账号" prop="bank">
            <el-input v-model="form.bank" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="form.bank" />
          </el-form-item>
          <el-form-item label="银行账号" prop="bank_account">
            <el-input v-model="form.bank_account" />
          </el-form-item>
          <el-form-item label="appKey" prop="app_key">
            <el-input v-model="form.app_key" />
          </el-form-item>
          <el-form-item label="appSecret" prop="app_secret">
            <el-input v-model="form.app_secret" />
          </el-form-item>
          <el-form-item label="用户名" prop="user_name">
            <el-input v-model="form.user_name" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="form.password" />
          </el-form-item>
          <el-form-item label="盐值" prop="user_salt">
            <el-input v-model="form.user_salt" />
          </el-form-item>
        </template>
        <el-form-item label="电话/邮箱" prop="tel">
          <el-input v-model="form.tel" />
        </el-form-item>
        <el-form-item label="开票人" prop="drawer">
          <el-input v-model="form.drawer" />
        </el-form-item>
        <el-form-item label="收款人" prop="payee">
          <el-input v-model="form.payee" />
        </el-form-item>
        <el-form-item label="复核人" prop="inspector">
          <el-input v-model="form.inspector" />
        </el-form-item>
        <el-form-item label="开票终端" prop="invoice_client">
          <el-input v-model="form.invoice_client" type="textarea" autosize />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" type="number"></el-input>
          <div class="el-form-item__info" style="line-height: 1.5;">数字越小优先级越高</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveDisc">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="绑定房产"
      :visible.sync="pindexModal"
      width="60%"
      :before-close="handleFromClose"
    >
      <el-form :model="pindexFrom" label-width="80px">
        <el-form-item label="项目">
          <div style="width: 100%; height: 400px; overflow-y: scroll">
            <el-tree
              :data="pindexList"
              :props="{ label: 'name', children: 'id' }"
              node-key="id"
              show-checkbox
              ref="tree"
              :default-checked-keys="defaultCheckedKeys"
            >
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveProject">保存</el-button>
          <el-button @click="handleFromClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <invoice-digitization
      :dialog-visible.sync="digitizationModel"
      :disc-id="discId"
      @close="closeDigitization"
    />
  </div>
</template>

<script>
import invoiceDigitization from "./invoiceDigitization.vue";
export default {
  name: "FinanceInvoiceDiscManage",
  components: { invoiceDigitization },
  data() {
    return {
      modal: false,
      listData: [],
      searchForm: {
        keyword: "",
        page: 1,
        pagesize: 10,
        totalCount: 0,
      },
      form: {
        id: "",
        name: "",
        tax_number: "",
        address: "",
        bank: "",
        tel: "",
        drawer: "",
        payee: "",
        inspector: "",
        remark: "",
        invoice_client: "",
        is_digitization: false,
        bank_account: "",
        app_key: "",
        app_secret: "",
        user_name: "",
        password: "",
        user_salt: "",
        sort : "",
      },
      pindexFrom: {
        id: "",
        pindex_ids: [],
      },
      pindexList: [],
      pidSelect: [],
      pindexModal: false,
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        tax_number: [
          { required: true, message: "请填写纳税人识别号", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写地址/电话", trigger: "blur" },
        ],
        bank: [{ required: true, message: "请填写开户行", trigger: "blur" }],
        bank_account: [
          { required: true, message: "请填写银行账号", trigger: "blur" },
        ],
        tel: [{ required: true, message: "请填写电话/邮箱", trigger: "blur" }],
        drawer: [{ required: true, message: "请填写开票人", trigger: "blur" }],
        payee: [{ required: true, message: "请填写收款人", trigger: "blur" }],
        inspector: [
          { required: true, message: "请填写复核人", trigger: "blur" },
        ],
        invoice_client: [
          { required: true, message: "请填写开票终端", trigger: "blur" },
        ],
        app_key: [{ required: true, message: "请填写appKey", trigger: "blur" }],
        app_secret: [
          { required: true, message: "请填写appSecret", trigger: "blur" },
        ],
        user_name: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
        user_salt: [{ required: true, message: "请填写盐值", trigger: "blur" }],
      },
      defaultCheckedKeys: [],
      digitizationModel: false,
      discId: "",
    };
  },
  mounted() {
    this.search(1);
    this.pindex();
  },
  watch: {},
  methods: {
    saveDisc() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/InvoiceDisc/saveDisc", this.form, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search(1);
                this.handleClose();
              } else {
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
        }
      });
    },
    search(page) {
      this.searchForm.page = page;
      this.$myhttp
        .post("admin/InvoiceDisc/index", this.searchForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.searchForm.totalCount = backdata.data.totalCount;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    modals() {
      this.form = {
        id: "",
        name: "",
        tax_number: "",
        address: "",
        bank: "",
        tel: "",
        drawer: "",
        payee: "",
        inspector: "",
        remark: "",
        invoice_client: "",
      };
      this.modal = true;
    },
    handleClose() {
      this.modal = false;
    },
    edit(id) {
      this.modal = true;
      this.view(id);
    },
    view(id) {
      this.$myhttp
        .post(
          "admin/InvoiceDisc/view",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.form = backdata.data.data;
            this.defaultCheckedKeys =
              backdata.data.data.pindex_ids.length > 0
                ? backdata.data.data.pindex_ids
                : [];
            if (this.pindexModal === true) {
              this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            }
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    del(id) {
      this.$confirm("确定要删除该税盘吗", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$myhttp
          .post(
            "admin/InvoiceDisc/delete",
            { id },
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            if (backdata.data.code == 200) {
              this.search(1);
              this.$message.success(backdata.data.msg);
            } else {
              this.$message.error(backdata.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },
    project(row) {
      this.pindexModal = true;
      this.view(row.id);
      this.pindexFrom = {
        id: row.id,
        pindex_ids: [],
      };
    },
    digitization(row) {
      this.digitizationModel = true;
      this.discId = row.id;
    },
    closeDigitization() {
      this.digitizationModel = false;
      this.discId = "";
    },
    pindex() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.pindexList = backdata.data.data.map((item) => {
              return { name: item.name, id: item.id };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    handleFromClose() {
      this.pindexModal = false;
    },
    saveProject() {
      var pindex_ids = this.$refs.tree.getCheckedKeys();
      this.pindexFrom.pindex_ids = pindex_ids;
      this.$myhttp
        .post("admin/InvoiceDisc/saveProject", this.pindexFrom, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.handleFromClose();
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/invoiceDisc.vue